import React from 'react';
import { CIBIL_DETAILS, STATE_STATUS } from '../../constants';
import { Map ,List} from "immutable";
import { Table } from '../../components';
import { Button, message } from 'antd';
import DbOnboardingService from '../../services/db-onboarding-service';

export default class CibilDetailTable extends React.Component{
    downloadCibil = (associate) => {
        message.loading("Downloading Cibil" , 0);
        DbOnboardingService.cibilDownload(associate)
        .then((response) => {
            if(response.data.link){
                window.open(response.data.link)
            }else{
                message.destroy();
                message.error("Something Went Wrong!")
            }
        })
        .catch(err => {
            message.destroy();
            message.error("Something Went Wrong!")
        });
    }
    render(){
        return (
            <Table
            columns={CIBIL_DETAILS.map(
                ({
                    onCellGenerator,
                    editable,
                    ...restColFields
                }) => {
                    if (!onCellGenerator || !editable) {
                        return { ...restColFields };
                    }
                    return {
                        onCell: onCellGenerator(
                            this.handleSave,
                            restColFields
                        ),
                        ...restColFields
                    };
                }
            )}
            checkedColumns={[]}
            data={this.props.associate && this.props.associate.map(_ => {
                let row = _;
                let cibil_report = this.props.cibilDocuments && (this.props.cibilDocuments
                    .find(__ => __.associate == _.id && __.document == 51 && __.case == this.props.caseId) || {}).file;

                let cibil_supported_report = this.props.cibilDocuments && this.props.cibilDocuments
                    .filter(__ => __.associate == _.id && __.document == 52 && __.case == this.props.caseId)
                    .map(_ => _.file);
                row = row
                    .set("cibil_report", <Button onClick={() => this.downloadCibil(_.id)}>Download</Button>)
                    .set("cibil_supported_report", new List(cibil_supported_report))
                    .set("cibil_score", _.getIn(["cibil_score"]))
                    .set("cibil_os", _.getIn([ "cibil_os"]))
                    .set("personal_cibil_score", _.getIn([ "personal_cibil_score"]))
                    .set("cibil_score_range", _.getIn([ "cibil_score_range"]))
                    .set("crif_score", _.getIn([ "crif_score"]))
                    .set("cibil_remarks", _.getIn([ "cibil_remarks"]))
                    .set("bureau", _.getIn([ "applicable_bureau"]))
                    .set("is_new_to_credit", _.getIn([ "is_new_to_credit"]))
                    .set("comments", _.getIn([ "credit_checker_remarks", "comments"]))
                    .set("conditions", _.getIn([ "credit_checker_remarks", "conditions"]))
                    .set("descriptions", _.getIn([ "credit_checker_remarks", "descriptions"]));
                return row;
            }).toList()}
            showTitle={false}
            showTopSection={false}
            pagination={false}
            keyFilter={"id"}
            noRowSelection={true}
            className={"inbox-table"}
        />
        )
    }
}